import { useAppSelector } from "../app";

export function useCanViewCloseOutUnderEngagement() {
  const { data } = useAppSelector((state) => state.userAccess);
  return data.userAccess.view_closeout_forms === "yes";
}
